import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';

import { AppCard } from '../general';
import { PieSeries } from '../../models/chart/chart';

const defaultOptions: ApexOptions = {
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: 'bottom',
        },
      },
    },
  ],
};

const PieChartWidget = (props: {
  className?: string;
  title: string;
  chartHeight?: string;
  pieSeries: PieSeries | undefined;
}): JSX.Element => {
  const { className, title, chartHeight, pieSeries } = props;

  if (!pieSeries || !pieSeries.data || pieSeries.data.length === 0) {
    return (
      <AppCard className={className} title={title}>
        <div style={{ height: chartHeight ?? '275px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a0a0a0', fontSize: '0.85rem' }}>
          No data available
        </div>
      </AppCard>
    );
  }

  const chartOptions: ApexOptions = {
    ...defaultOptions,
    labels: pieSeries.labels || [],
  };

  return (
    <AppCard className={className} title={title}>
      <Chart
        key={pieSeries.labels?.join(',') ?? 'pie'}
        width="100%"
        height={chartHeight ?? '275px'}
        options={chartOptions}
        series={pieSeries.data}
        type="pie"
      />
    </AppCard>
  );
};

export default PieChartWidget;
